import { radioCardGroupStandard } from 'humanity/components/radioCardGroup';

export const formikRadioCardGroupStandard = {
  ...radioCardGroupStandard,
};
